export enum NotificationTarget {
  AudienceStatus = 'audience-status',
  Broadcast = 'broadcast',
  Export = 'export',
  ExportForUser = 'export-for-user',
  Quantity = 'quantity',
  QuantityAudience = 'quantity-audience',
  QuantityForUser = 'quantity-for-user',
  SecretKeyApprove = 'secret-key-approve',
  SecretKeyDeny = 'secret-key-deny',
  SecretKeyRequest = 'secret-key-request',
  Snapshot = 'snapshot',
}
